import { FC, ReactElement, useMemo, useState } from 'react';
import { createContext } from 'use-context-selector';

interface RequestSupportModalContextProps {
  isOpenedReportErrorModal: boolean;
  handleCloseReportBugModal: () => void;
  handleOpenReportBugModal: () => void;
  isOpenedRequestHostOpsModal: boolean;
  setIsOpenedRequestHostOpsModal: (open: boolean) => void;
}

export const RequestSupportModalContext = createContext<RequestSupportModalContextProps>({
  isOpenedReportErrorModal: false,
  handleCloseReportBugModal: () => {},
  handleOpenReportBugModal: () => {},
  isOpenedRequestHostOpsModal: false,
  setIsOpenedRequestHostOpsModal: (open: boolean) => open,
});

export const RequestSupportModalProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [isOpenedReportErrorModal, setIsOpenedReportErrorModal] = useState(false);
  const [isOpenedRequestHostOpsModal, setIsOpenedRequestHostOpsModal] = useState(false);

  const handleCloseReportBugModal = () => {
    setIsOpenedReportErrorModal(false);
  };

  const handleOpenReportBugModal = () => {
    setIsOpenedReportErrorModal(true);
  };

  const handleIsOpenedRequestHostOpsModal = (open: boolean) => {
    setIsOpenedRequestHostOpsModal(open);
  };

  const value = useMemo(
    () => ({
      isOpenedReportErrorModal,
      handleCloseReportBugModal,
      handleOpenReportBugModal,
      isOpenedRequestHostOpsModal,
      setIsOpenedRequestHostOpsModal: handleIsOpenedRequestHostOpsModal,
    }),
    [
      isOpenedReportErrorModal,
      handleCloseReportBugModal,
      handleOpenReportBugModal,
      isOpenedRequestHostOpsModal,
      setIsOpenedRequestHostOpsModal,
    ],
  );

  return (
    <RequestSupportModalContext.Provider value={value}>
      {children}
    </RequestSupportModalContext.Provider>
  );
};
